// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__25klQ","head":"ProcedureTableInfo_head__31Anq"};